import { AbstractControl, ValidatorFn } from '@angular/forms';
import dayjs, { Dayjs } from 'dayjs';

export function dateOfBirthValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value) {
      control.markAsTouched();
      const selectedDate: Dayjs = control.value;
      if (selectedDate > dayjs()) {
        return { futureDate: true };
      }
    }
    return null;
  };
}
